import { DriveFolderUpload, Star, StarBorder } from '@mui/icons-material'
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Camera, Image, VideoIcon } from 'lucide-react'
import imageTech1 from "../../assets/svg/Ellipse1.svg"
import imageTech2 from "../../assets/svg/Ellipse 12.svg"
import imageTech3 from "../../assets/svg/Ellipse 12.svg"

const FinishOrderConfirmation = () => {
        const [showModal, setShowModal] = useState(false)
         const [showUploadModal, setShowUploadModal] = useState(false)
         const [showReview, setShowReview] = useState(false)
         const [newOrderShow, setNewOrderShow] = useState(false)
         const [executeOrderShow, setExecuteOrderShow] = useState(false)

        const handleShowModal = () => {
            setShowModal(true)
        }
        const handleCloseModal = () => {
            setShowModal(false)
        }
            
               const handleUploadShowModal = () =>{
                setShowUploadModal(true)
            }
            const handleUploadCloseModal = () =>{
                setShowUploadModal(false)
            }
            const handleOrderReviewModalShow = ()=>{
                setShowReview(true)
            }
            const handleOrderReviewModalClose = ()=>{
                setShowReview(false)
            }
            const handleAddNewOrderRequestShow = ()=>{
                setNewOrderShow(true)
            }
            const handleAddNewOrderRequestClose = ()=>{
                setNewOrderShow(false)
            }
              const handleExecuteOrderShow = ()=>{
                setExecuteOrderShow(true)
            }
              const handleExecuteOrderClose = ()=>{
                setExecuteOrderShow(false)
            }
  return (
     <>
            <button onClick={handleShowModal} className="btn btn-dark px-5 mx-3 my-2">
                تأكيد انهاء الطلب
            </button>
            <button onClick={handleOrderReviewModalShow} className="btn btn-dark px-5 mx-3 my-2">
                تقييم الطلب
            </button>
            <button onClick={handleAddNewOrderRequestShow} className="btn btn-dark px-5 mx-3 my-2">
                طلب إضافة خدمة جديدة للطلب
            </button>
            <button onClick={handleExecuteOrderShow} className="btn btn-dark px-5 mx-3 my-2">
                مراجعة تنفيذ الفني للطلب
            </button>
             <Modal show={executeOrderShow} onHide={handleExecuteOrderClose}>
                    <Modal.Header closeButton>
                        <Modal.Title className='fs-4 text-center m-0'>
                            مراجعة تنفيذ الفني للطلب                 
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{direction:"rtl"}} className=''>
                    <div className="mx-3 ">
                          <div className="my-3 text-center">
                    <h5 className='main-modal-color'>الفني أكد أنه أنهى تنفيذ الخدمات المطلوبة. يرجى مراجعة التفاصيل والتأكد من جودة التنفيذ قبل اعتماد إنهاء الطلب.</h5>

                      </div>
                  
                   
                    <div  className="w-100 mt-4">

                                        <button className="btn btn-dark px-5 w-100">بدأ المراجعه</button>


                                      </div>
                    </div>
                    </Modal.Body>
                </Modal>
            <Modal show={newOrderShow} onHide={handleAddNewOrderRequestClose}>
                    <Modal.Header closeButton>
                        <Modal.Title className='fs-4 text-center m-0'>
                       طلب إضافة خدمة جديدة للطلب
    
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{direction:"rtl"}} className=''>
                    <div className="mx-3">
                          <div className="my-3 text-center">
                    <h5 className='main-modal-color'>الفني طلب إضافة خدمة جديدة أثناء تنفيذ الطلب. يرجى مراجعة التفاصيل أدناه والموافقة أو الرفض حسب الحالة.</h5>

                      </div>
                   <div className="">
                       <div class="accordion " id="accordionExample">
  <div class="accordion-item remove-border">
    <h2 class="accordion-header accordion-header-responsive">
      <button class="accordion-button bg-transparent fix-accordion-dir" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
       عرض تفاصيل الخدمه المضافه للطلب
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div class="accordion-body add-order-request">
          <div className="d-flex align-items-center gap-2">
            <h6 className='m-0 main-modal-color'>اسم الخدمه :</h6>
            <p className="m-0">تغيير بطارية إضافية</p>
        </div>
        <div className="d-flex align-items-center gap-2">
            <h6 className='m-0 main-modal-color'>سبب الإضافة :</h6>
            <p className="m-0">البطارية الحالية غير قابلة لإعادة الشحن</p>
        </div>
        <div className="d-flex align-items-center gap-2">
            <h6 className='m-0 main-modal-color'>السعر المتوقع :</h6>
            <p className="m-0">950 ج.م</p>
        </div>
      
      </div>
    </div>
  </div>
</div>
                    
                      
                   </div>
                   
                    <div  className="d-flex justify-content-center align-items-center my-5 gap-4">

                                        <button className="btn btn-dark px-4">تأكيد الاضافه</button>
                                        <button onClick={handleAddNewOrderRequestClose}  className="btn border border-danger text-danger px-5">رفض</button>


                                      </div>
                    </div>
                    </Modal.Body>
                </Modal>
            <Modal show={showReview} onHide={handleOrderReviewModalClose}>
                    <Modal.Header closeButton>
                        <Modal.Title className=' text-center m-0'>
                       تقييم الطلب
    
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{direction:"rtl"}}>
                    <div className="mx-3">
                          <div className="my-3 text-center">
                    <h5 className='main-modal-color'>يرجى تقييم تجربة تنفيذ الطلب بعد المراجعة النهائية</h5>

                      </div>
                   <div className="">
                       <div className="d-flex align align-items-center justify-content-between my-4">
                        <div className="d-flex align-items-center gap-2">
                            <img src={imageTech1} alt="tech-review-image" />
                            <h6 className='main-modal-color m-0'>تقييم العميل</h6>
                        </div>
                        <div className="d-flex  align-items-center">
                           <Star sx={{color:"#F8C63D",fontSize:30}}/>
                           <Star sx={{color:"#F8C63D" ,fontSize:30}}/>
                           <Star sx={{color:"#F8C63D" ,fontSize:30}}/>
                           <Star sx={{color:"#F8C63D" ,fontSize:30}}/>
                           <StarBorder sx={{color:"#F8C63D" ,fontSize:30}}/>

                        </div>
                      </div>
                      <div className="d-flex align align-items-center justify-content-between my-4">
                        <div className="d-flex align-items-center gap-2">
                            <img src={imageTech2} alt="tech-review-image" />
                            <h6 className='main-modal-color m-0'>تقييم السواق</h6>
                        </div>
                        <div className="d-flex  align-items-center">
                           <Star sx={{color:"#F8C63D",fontSize:30}}/>
                           <Star sx={{color:"#F8C63D" ,fontSize:30}}/>
                           <Star sx={{color:"#F8C63D" ,fontSize:30}}/>
                           <Star sx={{color:"#F8C63D" ,fontSize:30}}/>
                           <Star sx={{color:"#F8C63D" ,fontSize:30}}/>

                        </div>
                      </div>
                      <div className="d-flex align align-items-center justify-content-between my-4">
                        <div className="d-flex align-items-center gap-2">
                            <img src={imageTech3} alt="tech-review-image" />
                            <h6 className='main-modal-color m-0'>تقييم الفني</h6>
                        </div>
                        <div className="d-flex  align-items-center">
                           <Star sx={{color:"#F8C63D",fontSize:30}}/>
                           <StarBorder sx={{color:"#F8C63D" ,fontSize:30}}/>
                           <StarBorder sx={{color:"#F8C63D" ,fontSize:30}}/>
                           <StarBorder sx={{color:"#F8C63D" ,fontSize:30}}/>
                           <StarBorder sx={{color:"#F8C63D" ,fontSize:30}}/>

                        </div>
                      </div>
                   </div>
                     <div className="my-3">
                    <h6>ملاحظات اضافيه</h6>
        <textarea style={{ padding: 20, borderRadius: 10, border: "solid 2px #D8D8D8", }} rows={3} className='w-100' placeholder='يمكنك إضافة ملاحظات على الطلب أو على أداء الفريق' id=""></textarea>

                  </div>
                    <div  className="d-flex justify-content-center align-items-center my-5 gap-4">

                                        <button className="btn btn-dark px-4">حفظ التقييم</button>
                                        <button onClick={handleOrderReviewModalClose} className="btn btn-light px-5">الغاء</button>


                                      </div>
                    </div>
                    </Modal.Body>
                </Modal>
             <Modal show={showUploadModal} onHide={handleUploadCloseModal}>
                    <Modal.Header closeButton>
                        <Modal.Title className=' text-center m-0'>
                       اضافة ملف
    
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{direction:"rtl"}}>
                      <div className="d-flex align-items-center gap-4 p-3">
                        <input type="file" className='d-none' id="upload-file" />
                        <label htmlFor="upload-file"><div className="text-center cursor">
                            <div style={{border:"1px solid #C6C6C6" ,borderRadius:"50%"}} className=' p-3 d-flex justify-content-center my-1'>
                              <Image  className='main-text-color'/>
                            </div>
                            <p>ملفاتي</p>
                        </div></label>
                        
                      
                              <div className="text-center">
                            <div style={{border:"1px solid #C6C6C6" ,borderRadius:"50%"}} className=' p-3 d-flex justify-content-center my-1'>
                              <Camera  className='main-text-color'/>
                            </div>
                            <p>كاميرا</p>
                        </div>
                    
                         <div className="text-center">
                            <div style={{border:"1px solid #C6C6C6" ,borderRadius:"50%"}} className=' p-3 d-flex justify-content-center my-1'>
                              <VideoIcon  className='main-text-color'/>
                            </div>
                            <p>فيديو</p>
                        </div>
    
                      </div>
                    </Modal.Body>
                </Modal>
            <Modal show={showModal} onHide={handleCloseModal} dialogClassName='custom-modal-campaigns-width'>
                <Modal.Header className='d-flex align-items-center' >
                    <Modal.Title className='fw-bold fs-5 text-center m-0'>
                        تأكيد إنهاء الطلب
                          </Modal.Title>
                 
                </Modal.Header>
                <Modal.Body className='m-2' style={{ direction: "rtl" }}>
                  <div className="text-center">
                    <h5 className='main-modal-color'>هل أنت متأكد من إنهاء هذا الطلب؟ سيتم حفظ جميع البيانات وإغلاق الطلب بعد تأكيدك.</h5>
                  </div>
                  <div className='my-4'>
                    <h6>
                        يرجى التأكد من الآتي قبل الإنهاء:
                    </h6>
                    <ul className='mx-4' style={{listStyleType:"square" , color:"#535353"}}>
                        <li className='my-2'>تم تنفيذ جميع الخدمات المطلوبة.</li>
                        <li className='my-2'>تم مراجعة التنفيذ بدقة.</li>
                        <li className='my-2'>لا توجد ملاحظات أو خدمات ناقصة.</li>
                    </ul>
                  </div>
                  <div className="">
                    <h6>ملاحظات اضافيه</h6>
        <textarea style={{ padding: 20, borderRadius: 10, border: "solid 2px #D8D8D8", }} rows={4} className='w-100' placeholder='اضف ملاحظاتك' id=""></textarea>

                  </div>
                      <div className='my-3'>
                                          <p>اضافة مرفقات</p>
                                          <div onClick={handleUploadShowModal} style={{border:"2px dashed #C6C6C6"}} className="p-4 w-100 rounded-3 d-flex justify-content-center align-items-center"
                                          
                                          >
                                              <div className='text-center'>
                                                  <DriveFolderUpload sx={{fontSize:"50px",color:"#535353"}}/>
                                                  <p style={{color:"#535353",margin:0}}>اضف ملف </p>
                                                  <p style={{color:"#828282",margin:0}}>أرفق صورة، فيديو، أو تسجيل صوتي.</p>
                                              </div>
                                          </div>
                  
                                      </div>
                                      <div  className="d-flex justify-content-center align-items-center my-5 gap-4">

                                        <button className="btn btn-dark px-4">تأكيد وانهاء الطلب</button>
                                        <button onClick={handleCloseModal} className="btn btn-light px-5">الغاء</button>

                                      </div>
                </Modal.Body>

            </Modal>
           
        </>
  )
}

export default FinishOrderConfirmation